<div class="header-container">
    <div class="header-title">{{headerTitle}}</div>

    <div class="header-button" (click)="onButtonClick.emit()" *ngIf="isShowButton">
        <img src="../../../../../../assets/icons/icons-s-idebar-add-active-plus.svg" />
        <div class="button-text">{{buttonTitle}}</div>
    </div>
</div>